
export class WorkerRequest {
 
    workerId: number;
    workerCode: number;
    workerName: string;
    updatedUser?: string;
    versionFlag?: number;
    isActive?: boolean;
    constructor(workerId: number,workerCode:number,workerName: string, updatedUser?: string,versionFlag?: number, isActive?:boolean){
        this.workerId = workerId;
        this.workerCode = workerCode
        this.workerName = workerName
        this.updatedUser = updatedUser
        this.versionFlag = versionFlag
        this.isActive = isActive

        
    }
}